<div class="grid-footer">
  <div class="d-inline-flex align-items-center">
    <ap-pagination
      [ngModel]="currentPage"
      [min]="1"
      [max]="totalPages"
      (onChange)="changePage($event)">
    </ap-pagination>
    @if (extendedPagination) {
      <select
        id="rows-by-page"
        [ngModel]="rowByPage"
        (ngModelChange)="onPageSizeChange($event)"
        class="dropdown">
        @for (option of options; track option.value) {
          <option [ngValue]="option.value">{{ option.key }}</option>
        }
      </select>
    } @else {
      <select
        id="rows-by-page"
        [(ngModel)]="paginationSetting.rowByPage"
        class="dropdown"
        (change)="select($event)">
        @for (option of options; track $index) {
          <option [value]="option.value">{{ option.key }}</option>
        }
      </select>
    }
  </div>
  <div>
    <span>{{ currentRows }}</span> of
    <span>{{ paginationSetting.totalItems }}</span>
    items
  </div>
</div>
